
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M9.50001 10C11.433 10 13 8.43302 13 6.50001C13 4.56701 11.433 3 9.50001 3C7.56701 3 6 4.56701 6 6.50001C6 8.43302 7.56701 10 9.50001 10Z"></path><path d="M16.3039 3.49997C17.3203 4.11242 18.0001 5.22683 18.0001 6.49998C18.0001 7.77313 17.3203 8.88754 16.3039 9.49999"></path><path d="M2 20.4001V21.0001H17V20.4001C17 18.1598 17 17.0397 16.5641 16.1841C16.1806 15.4314 15.5686 14.8195 14.816 14.436C13.9603 14 12.8402 14 10.6 14H8.40002C6.15981 14 5.03971 14 4.18405 14.436C3.43139 14.8195 2.81947 15.4314 2.43598 16.1841C2 17.0397 2 18.1598 2 20.4001Z"></path><path d="M22 21V20.4C22 18.1598 22 17.0397 21.5641 16.1841C21.1806 15.4314 20.5686 14.8195 19.8159 14.436"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiUsermanagement",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
